import { render, staticRenderFns } from "./TheEventPostPurchase.vue?vue&type=template&id=6720f7c3&"
import script from "./TheEventPostPurchase.vue?vue&type=script&lang=js&"
export * from "./TheEventPostPurchase.vue?vue&type=script&lang=js&"
import style0 from "./TheEventPostPurchase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports